import { usePlayerStoreApi } from "@utils/player/core/usePlayer";
import React from "react";
import { useCallback } from "react";

import { useState } from "react";
import { runOnJS, useAnimatedStyle, withTiming } from "react-native-reanimated";
import { Gesture, GestureDetector } from "react-native-gesture-handler";

import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import Animated from "react-native-reanimated";
import { usePlayerControls } from "@utils/player";

import {
  selectActiveQueueItemId,
  selectIsPlaying,
} from "@utils/player/core/selectors";

interface PlayPauseButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
}

const PlayPauseButton = ({ children, disabled }: PlayPauseButtonProps) => {
  const playerStore = usePlayerStoreApi();

  // PERFORMANCE: Don't subscribe to player state - read from store directly in callback
  // This prevents re-renders when switching queues
  const { togglePlay } = usePlayerControls();

  // State to control indicator visibility
  const [showIndicator, setShowIndicator] = useState({
    show: false,
    state: "pause",
  });

  const buttonStyle = useAnimatedStyle(() => {
    return {
      opacity: withTiming(showIndicator.show ? 1 : 0, {
        duration: showIndicator.show ? 150 : 350,
      }),
    };
  });

  const togglePlayPause = useCallback(() => {
    // Read all player state directly from store - no subscriptions, no re-renders
    const store = playerStore.getState();
    const isPlaying = selectIsPlaying(store);
    const activeQueueItemId = selectActiveQueueItemId(store);

    if (isPlaying) {
      setShowIndicator({
        show: true,
        state: "pause",
      });
    } else {
      setShowIndicator({
        show: true,
        state: "play",
      });
    }

    if (activeQueueItemId) {
      const hasReachedPlaybackLimit = store.hasReachedPlaybackLimit;
      const playbackLimitConfig = store.playbackLimitConfig;

      if (hasReachedPlaybackLimit && playbackLimitConfig.enabled) {
        playbackLimitConfig.onLimitReached();
      } else {
        togglePlay();
      }
    }

    setTimeout(() => {
      setShowIndicator((prev) => ({
        ...prev,
        show: false,
      }));
    }, 350);
  }, [togglePlay]);

  const playPauseTapGesture = Gesture.Tap()
    .enabled(!disabled)
    .onEnd(() => {
      runOnJS(togglePlayPause)();
    });

  return (
    <>
      <GestureDetector gesture={playPauseTapGesture}>
        <LBox flex={1}>{children}</LBox>
      </GestureDetector>
      <Animated.View
        pointerEvents="none"
        style={[
          buttonStyle,
          {
            position: "absolute",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            width: 90,
            height: 90,
            borderRadius: 999,
            backgroundColor: "rgba(0,0,0,0.4)",
          },
        ]}
      >
        <LIcon
          name={showIndicator.state === "play" ? "play" : "pause"}
          size={42}
          pl={showIndicator.state === "play" ? "s3" : "zero"}
        />
      </Animated.View>
    </>
  );
};

export default PlayPauseButton;
